// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uses-link[data-v-0aff2e18]{color:#08c!important;font-weight:400;cursor:pointer}", ""]);
// Exports
module.exports = exports;
